import {NgModule} from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';

import {InformationRoutingModule} from './information-routing.module';
import {InformationComponent} from "./information.component";
import {PagesModule} from "../pages/pages.module";
import {TranslateModule} from "@ngx-translate/core";
import {AttributionComponent} from "./attribution/attribution.component";


@NgModule({
  declarations: [
    AttributionComponent,
    InformationComponent
  ],
  imports: [
    CommonModule,
    InformationRoutingModule,
    PagesModule,
    NgIf,
    TranslateModule
  ]
})
export class InformationModule { }
